import { Icon } from '@eventbrite/eds-icon';
import { Calendar, Cart } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import classNames from 'classnames';
import React, { FunctionComponent } from 'react';
import styles from './EmptyPane.module.scss';

export const EmptyPane: FunctionComponent<{ isSeriesParentPage: boolean }> = ({
    isSeriesParentPage,
}) => {
    const { iconType, selectEvent } = isSeriesParentPage
        ? {
              iconType: <Calendar />,
              selectEvent: (
                  <div
                      className="eds-text-bs eds-text-color--ui-700 eds-l-mar-top-2"
                      data-testid="pane-empty-cart-cta-text"
                  >
                      {gettext('SELECT AN EVENT')}
                  </div>
              ),
          }
        : { iconType: <Cart />, selectEvent: null };

    return (
        <div
            className={classNames('eds-align--center', styles.root)}
            data-spec="pane-empty-cart-container"
        >
            <Icon
                __containerClassName={styles.icon}
                type={iconType}
                size="medium"
                color="grey-300"
            />
            {selectEvent}
        </div>
    );
};
